import React, { useState } from "react";
import {
    Box, Heading, Input, Button, SimpleGrid, FormControl, FormLabel, FormErrorMessage, useToast,
} from '@chakra-ui/react';
import { FileDown } from 'lucide-react';
import { baixarRelatorioNcmPadrao } from "../services/api";
import { dataLocal, validarPeriodo } from "../utils/notasFiscais";

const ultimos7Dias = () => {
    const hoje = new Date();
    return {
        data_inicio: dataLocal(new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - 7)),
        data_fim: dataLocal(new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - 1)),
    };
};

const mensagemErro = async (error) => {
    if (error?.response?.status === 403) return 'Relatório restrito a administradores.';
    const corpo = error?.response?.data;
    if (corpo instanceof Blob) {
        try {
            return JSON.parse(await corpo.text())?.message || 'Ocorreu um erro inesperado.';
        } catch {
            return 'Ocorreu um erro inesperado.';
        }
    }
    return corpo?.message || 'Ocorreu um erro inesperado.';
};

const RelatorioNcmPadrao = () => {
    const [filtros, setFiltros] = useState(ultimos7Dias);
    const [baixando, setBaixando] = useState(false);
    const toast = useToast();
    const erroPeriodo = validarPeriodo(filtros);

    const alterar = (e) => {
        const { name, value } = e.target;
        setFiltros((anterior) => ({ ...anterior, [name]: value }));
    };

    const baixar = async () => {
        if (erroPeriodo) return;
        setBaixando(true);
        try {
            await baixarRelatorioNcmPadrao(filtros);
        } catch (error) {
            toast({ title: 'Erro ao gerar o relatório', description: await mensagemErro(error), status: 'error', duration: 7000, isClosable: true });
        } finally {
            setBaixando(false);
        }
    };

    return (
        <Box p={{ base: 4, md: 6 }} bg="white" borderRadius="lg" borderWidth="1px" w="100%" boxShadow="sm">
            <Heading size="md" mb={4}>Vendido com NCM padrão</Heading>
            <SimpleGrid columns={{ base: 1, md: 3 }} spacing={4} alignItems="end">
                <FormControl isInvalid={!!erroPeriodo}>
                    <FormLabel fontSize="sm" mb={1}>Emissão de</FormLabel>
                    <Input type="date" name="data_inicio" value={filtros.data_inicio} onChange={alterar} max={filtros.data_fim || undefined} />
                </FormControl>
                <FormControl isInvalid={!!erroPeriodo}>
                    <FormLabel fontSize="sm" mb={1}>Emissão até</FormLabel>
                    <Input type="date" name="data_fim" value={filtros.data_fim} onChange={alterar} min={filtros.data_inicio || undefined} />
                    {erroPeriodo && <FormErrorMessage>{erroPeriodo}</FormErrorMessage>}
                </FormControl>
                <Button
                    leftIcon={<FileDown size={16} />}
                    colorScheme="orange"
                    onClick={baixar}
                    isLoading={baixando}
                    loadingText="Gerando..."
                    isDisabled={!!erroPeriodo}
                    w="full"
                >
                    Baixar CSV
                </Button>
            </SimpleGrid>
        </Box>
    );
};

export default RelatorioNcmPadrao;
